/* API Context */
import {getRequest, postRequest} from "../fetchWrapper";

/**
 * Récupération du header de l'agence.
 *
 * @param string $token Jeton d'authentification.
 * @param int $id Identifiant de l'agence.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAgencyHeader = (token, id) => {
    const url = `/api-v1/agency/${id}/header`
    return getRequest(url, token)
}

/**
 * Récupération de l'image par défaut pour un compte défunt de l'agence.*
 *
 * @param string $token Jeton d'authentification.
 * @param object $body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAgencyDefaultDeceasedImage = (token, id) => {
    const url = `/api-v1/agency/${id}/default/portrait/infos`
    return getRequest(url, token)
}

/**
 * Modification de l'image par défaut pour un compte défunt de l'agence.*
 *
 * @param string $token Jeton d'authentification.
 * @param object $body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updatetAgencyDefaultDeceasedImage = (token, body) => {
    const url = `/api-v1/agency/default/portrait/update`
    return postRequest(url, body, token)
}